import { apiClient } from './client'
import type { UserApp } from '@paperair/shared-types'

export type { UserApp }

export async function fetchMyApps(): Promise<UserApp[]> {
  const response = await apiClient.get<{ apps: UserApp[] }>('/users/me/apps')
  return response.data.apps
}

export async function requestHandoff(targetAppId: string): Promise<string> {
  const response = await apiClient.post<{ token: string }>('/auth/handoff', { targetAppId })
  return response.data.token
}
